import { Formik } from 'formik'
import { Col, Form, Modal, ModalHeader, Row } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import { AreaAddEditSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import TextField from '../../Input/TextInput'
import { useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'

function ModalAddArea(props) {
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const handleSubmit = async (values) => {
    try {
      setLoadingSubmit(true)
      values.warehouse_id = props.warehouseId
      const res = await api.post('/master/area/add', values)
      if (res.data.success) {
        props.onHide()
        props.refreshData()
        toast.success(res.data.message, {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoadingSubmit(false)
    }
  }

  return (
    <>
      <Modal {...props} centered>
        <ModalHeader closeButton>
          <Modal.Title>Add Area</Modal.Title>
        </ModalHeader>
        <Modal.Body>
          <Formik
            initialValues={{
              code: '',
              area_name: ''
            }}
            validationSchema={AreaAddEditSchema}
            onSubmit={(values) => {
              handleSubmit(values)
            }}
          >
            {({
              handleBlur,
              handleSubmit,
              handleChange,
              values,
              errors,
              touched,
              isValid,
              dirty
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Col md={4}>
                      <TextField
                        label="Code"
                        name="code"
                        value={values.code}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        placeholder="Enter Code"
                        required={true}
                      />
                    </Col>
                    <Col md={8}>
                      <TextField
                        label="Name"
                        name="area_name"
                        value={values.area_name}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        placeholder="Enter Name"
                        required={true}
                      />
                    </Col>
                  </Row>
                  <Modal.Footer>
                    <CustomCloseButton onClick={props.onHide} />
                    <CustomButton
                      onClick={handleSubmit}
                      variant={
                        !isValid || !dirty || loadingSubmit
                          ? 'secondary'
                          : 'warning'
                      }
                      disabled={!isValid || !dirty || loadingSubmit}
                      text={loadingSubmit ? 'Loading...' : 'Add'}
                      classNameValue={`text-white ${!isValid || !dirty || loadingSubmit ? 'opacity-25' : ''}`}
                    />
                  </Modal.Footer>
                </Form>
              )
            }}
          </Formik>
        </Modal.Body>
      </Modal>
      <Toaster />
    </>
  )
}

export default ModalAddArea
